/**
 * Free WhatsApp Invoice Sharing Utility (wa.me direct links)
 */

export function formatPhoneForWhatsApp(phone) {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 10) return `91${digits}`;
  if (digits.length === 12 && digits.startsWith('91')) return digits;
  return digits;
}

export function buildWhatsAppInvoiceText({
  hotelName,
  guestName,
  invoiceNumber,
  totalAmount,
  room,
  checkIn,
  checkOut,
  pdfLink,
  isCheckBill,
  hasSeparateBills,
  stayLink,
  extrasLink,
  damageLink,
  stayTotal,
  extrasTotal,
  damageTotal
}) {
  const hName = hotelName || 'Hotel Sri7 Inn';
  const gName = guestName ? `Dear ${guestName}` : 'Valued Guest';
  const docTitle = isCheckBill ? 'Check Bill Preview' : 'Checkout Invoice Summary';
  const invLabel = isCheckBill ? 'Check Bill' : 'Invoice No';
  const inv = (invoiceNumber && invoiceNumber !== 'CHECK-BILL' && invoiceNumber !== 'PREVIEW') ? `*${invLabel}:* ${invoiceNumber}\n` : '';
  const rm = room ? `*Room:* ${room}\n` : '';
  const dates = (checkIn && checkOut) ? `*Stay:* ${checkIn} to ${checkOut}\n` : '';
  const amt = totalAmount ? `*Total Amount:* Rs. ${Number(totalAmount).toLocaleString('en-IN')}\n` : '';

  let pdfStr = '';
  if (hasSeparateBills) {
    pdfStr = `📄 *SEPARATE BILL LINKS:*\n`;
    if (stayLink) pdfStr += `🏠 *Room Stay Bill (Rs. ${Number(stayTotal || 0).toLocaleString('en-IN')}):*\n${stayLink}\n\n`;
    if (extrasLink) pdfStr += `🛒 *Extra Services Bill (Rs. ${Number(extrasTotal || 0).toLocaleString('en-IN')}):*\n${extrasLink}\n\n`;
    if (damageLink) pdfStr += `⚠️ *Damage Bill (Rs. ${Number(damageTotal || 0).toLocaleString('en-IN')}):*\n${damageLink}\n\n`;
  } else if (pdfLink) {
    pdfStr = `📄 *View / Download ${isCheckBill ? 'Check Bill' : 'PDF Invoice'}:*\n${pdfLink}\n\n`;
  }

  return `🏨 *${hName}*
${gName},

Thank you for staying with us! Here is your *${docTitle}*:

${inv}${rm}${dates}${amt}
${pdfStr}Kindly verify the details before final billing. Thank you! 🙏✨`;
}

export function openWhatsAppInvoiceShare({
  phone,
  hotelName,
  guestName,
  invoiceNumber,
  reservationId,
  totalAmount,
  room,
  checkIn,
  checkOut,
  isCheckBill,
  hasSeparateBills,
  stayTotal,
  extrasTotal,
  damageTotal
}) {
  const cleanPhone = formatPhoneForWhatsApp(phone);
  
  const targetId = reservationId || invoiceNumber || room;
  const apiHost = window.location.hostname === 'localhost' ? 'localhost:4000' : window.location.host;
  const protocol = window.location.protocol;
  const baseParam = reservationId ? `resId=${encodeURIComponent(reservationId)}` : `inv=${encodeURIComponent(targetId)}`;
  
  const pdfLink = `${protocol}//${apiHost}/api/invoices/public?${baseParam}`;
  
  let stayLink = null;
  let extrasLink = null;
  let damageLink = null;

  if (hasSeparateBills) {
    stayLink = `${protocol}//${apiHost}/api/invoices/public?${baseParam}&type=stay`;
    if (extrasTotal > 0) extrasLink = `${protocol}//${apiHost}/api/invoices/public?${baseParam}&type=extras`;
    if (damageTotal > 0) damageLink = `${protocol}//${apiHost}/api/invoices/public?${baseParam}&type=damage`;
  }

  const text = buildWhatsAppInvoiceText({
    hotelName,
    guestName,
    invoiceNumber,
    totalAmount,
    room,
    checkIn,
    checkOut,
    pdfLink,
    isCheckBill,
    hasSeparateBills,
    stayLink,
    extrasLink,
    damageLink,
    stayTotal,
    extrasTotal,
    damageTotal
  });

  const encodedText = encodeURIComponent(text);
  
  const url = cleanPhone 
    ? `https://wa.me/${cleanPhone}?text=${encodedText}` 
    : `https://wa.me/?text=${encodedText}`;

  window.open(url, '_blank', 'noopener,noreferrer');
}
